import { AccountDetailForSelector } from '@varo/graphql-schema-types';
import React, { PropsWithChildren, useState } from 'react';

interface VLOCContextData {
  amount: string;
  lineOfCreditId?: string;
  sourceAccount?: AccountDetailForSelector;
}
export type VLOCContextProps = {
  vlocContextData?: VLOCContextData;
  setVLOCContextData: (vlocContextData?: VLOCContextData) => void;
};

export const VLOCContext = React.createContext<VLOCContextProps>({
  vlocContextData: { amount: '0.0' },
  setVLOCContextData: () => {},
});

const VLOCContextProvider = ({ children }: PropsWithChildren) => {
  const [vlocContextData, setVLOCContextData] = useState<VLOCContextData>();
  return (
    <VLOCContext.Provider
      value={{
        vlocContextData,
        setVLOCContextData,
      }}
    >
      {children}
    </VLOCContext.Provider>
  );
};

export default VLOCContextProvider;
